module.exports = __webpack_public_path__ + "img/working-time.3f5178ae.png";